module.exports = __webpack_public_path__ + "img/may_600.f751a252.png";